module.exports = __webpack_public_path__ + "img/ic_api.cfe2c92d.svg";